import React from 'react'
import PropTypes from 'prop-types'
import { OverlayTrigger, Popover } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'

function renderPopover({ title, body }) {
  return (
    <Popover>
      <h5>{title}</h5>
      {body.map((message, index) => <p key={index} dangerouslySetInnerHTML={{__html: message}} />)}
    </Popover>
  );
}

function HelpPopover({ popover }) {
  return (
    <OverlayTrigger trigger='click' placement='bottom' rootClose overlay={renderPopover(popover)}>
      <span className="help-popover">
        <FontAwesome name="question-circle" />
      </span>
    </OverlayTrigger>
  )
}

HelpPopover.propTypes = {
  popover: PropTypes.shape({
    title: PropTypes.string,
    body: PropTypes.arrayOf(PropTypes.string)
  })
}

export default HelpPopover



// WEBPACK FOOTER //
// ./src/components/HelpPopover/index.js